import React, { useState } from 'react';
import {
	Divider,
	Drawer,
	IconButton
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';

function SideDrawer(props) {
	const { children, displayDivider } = props;
	const [mobileOpen, setMobileOpen] = useState(false);
	const theme = useTheme();

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	const drawer = (
		<div style={{ padding: '15px' }}>
			{children[0]}
			{displayDivider !== 'none' ? <Divider /> : null}
			{children.slice(1)}
		</div>
	);

	return (
		<>
			<IconButton
				color="inherit"
				aria-label="open drawer"
				edge="end"
				onClick={handleDrawerToggle}
				style={{ outline: 0, margin: 0, padding: '5px' }}
				data-cy="mobileMenu"
			>
				<MoreVert style={{ fill: theme.palette.primary.main, fontSize: '30px' }} />
			</IconButton>
			<Drawer
				variant="temporary"
				anchor="right"
				open={mobileOpen}
				onClose={handleDrawerToggle}
				ModalProps={{
					keepMounted: true
				}}
			>
				{drawer}
			</Drawer>
		</>
	);
}

export default SideDrawer;
